import { render, staticRenderFns } from "./fileDisplay.vue?vue&type=template&id=4845f813&scoped=true"
import script from "./fileDisplay.vue?vue&type=script&lang=js"
export * from "./fileDisplay.vue?vue&type=script&lang=js"
import style0 from "./fileDisplay.vue?vue&type=style&index=0&id=4845f813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845f813",
  null
  
)

export default component.exports